// src/components/OwnerInfoBox.js

import React from 'react';
import { Box, Avatar, Typography, Rating } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useNavigate } from 'react-router-dom';

const OwnerInfoBoxStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(2),
}));

const OwnerInfoBox = ({ profilePicture, firstName, lastName, averageRating, zipCode, userId }) => {
    const navigate = useNavigate();
    return (
        <OwnerInfoBoxStyled onClick={() => navigate(`/users/${userId}`)}>
            <Avatar src={profilePicture} alt={firstName} sx={{ width: 64, height: 64, mr: 2 }}>
                {firstName?.[0]}
            </Avatar>
            <Box>
                <Typography variant="subtitle1">
                    {firstName} {lastName}
                </Typography>
                <Rating value={averageRating || 0} readOnly size="small" />
                <Box display="flex" alignItems="center" mt={0.5}>
                    <LocationOnIcon fontSize="small" color="action" />
                    <Typography variant="body2" color="textSecondary" ml={0.5}>
                        {zipCode}
                    </Typography>
                </Box>
            </Box>
        </OwnerInfoBoxStyled>
    );
};

export default OwnerInfoBox;
